import Vue from 'vue';
import { classToPositiveNumber } from './../../mixins/classToPositiveNumber';
import finRes from '../fin-res/finRes.vue';
import { mapGetters } from 'vuex';
export default Vue.extend({
    name: 'coinInfo',
    props: {
        isItOnTop: {
            type: Boolean,
            required: false,
            default: false
        },
        showDollarSign: {
            type: Boolean,
            required: false,
            default: false
        },
        course: {
            required: false,
            type: Object
        },
        list: {
            type: Array,
            required: false,
            default: () => []
        },
        selectedAsset: {
            type: String,
            required: false,
            default: ''
        },
        secondaryAsset: {
            type: Boolean,
            required: false,
            default: false
        },
        isFutures: {
            type: Boolean,
            required: false,
            default: true
        },
        finResetLoading: {
            type: Boolean,
            required: false,
            default: false
        },
        showCoinInfo: {
            type: Boolean,
            required: false,
            default: true
        },
        showAproxSign: {
            type: Boolean,
            required: false,
            default: false
        },
        title: {
            type: String,
            required: false,
            default: ''
        },
        iconName: {
            type: String,
            required: false,
            default: 'USDT-Icon'
        },
        name: {
            type: String,
            required: false,
            default: 'USDT'
        },
        finresValue: {
            type: Object,
            required: false,
            default: null
        },
        finresPercent: {
            type: Object,
            required: false,
            default: null
        },
        ratio: {
            type: Number,
            required: false
        },
        progressBarTranslateValue: {
            type: String,
            required: false
        },
        value: {
            type: String,
            required: false
        },
        fullValue: {
            type: String,
            required: true,
            default: ''
        },
        fullValueDeposit: {
            type: String,
            required: false,
            default: ''
        },
        deposit: {
            type: String,
            required: false,
            default: ''
        },
        hideFinres: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: Object.assign(Object.assign({}, mapGetters('mainPageModules', {
        getFuturesSettings: 'getFuturesSettings',
        getPositionsTable: 'getPositionsTable',
        getCourseUpdateDate: 'getCourseUpdateDate',
        getLimitsBidsTable: 'getLimitsBidsTable'
    })), { approxSign() {
            return this.isFutures && this.getFuturesSettings.multiAssets ? '≈ ' : '';
        }, showDeposit() {
            const hasPositions = this.getPositionsTable.items.some((item) => item.ticker.match(this.name));
            const hasLimits = this.getLimitsBidsTable.items.some((item) => item.ticker.match(this.name));
            return (hasPositions || hasLimits) && Boolean(this.deposit);
        } }),
    methods: {
        handleSelectInput(event) {
            this.$emit('update-selected-asset', event.value);
        },
        changeUSDToNative() {
            this.$emit('change-USD-converted-value', this.name);
        }
    },
    mixins: [classToPositiveNumber],
    components: { finRes }
});
